import React, { useMemo, useRef, useEffect, useState } from "react";
import { SearchBox } from "@fluentui/react";
import { isMobile } from "react-device-detect";
import "./LLMTopBar.css";

const SubMenuWithSearch = ({ items, type, onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const searchContainerRef = useRef(null);

  useEffect(() => {
    if (isMobile && searchContainerRef.current) {
      const input = searchContainerRef.current.querySelector("input");
      if (input) input.blur();
    }
  }, []);

  const filteredItems = useMemo(() => {
    if (!searchQuery) return items;
    return items.filter((item) => {
      const text = type === "agentic" ? item.label : item.title;
      return text.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }, [items, searchQuery, type]);

  return (
    <div
      className="agentic-report-submenu"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="agentic-report-search-header" ref={searchContainerRef}>
        <SearchBox
          placeholder="Search"
          underlined={false}
          autoComplete="off"
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          onChange={(_, newValue) => setSearchQuery(newValue)}
          styles={{
            root: {
              width: "100%",
              height: 32,
              background: "#f3f3f3",
              borderRadius: 4,
              border: "1px solid transparent",
              color: "#1b1b1b",
            },
            rootFocused: {
              background: "#ffffff",
              borderColor: "#0078d4",
            },
            field: {
              color: "#1b1b1b",
              fontSize: 14,
              backgroundColor: "transparent",
            },
            icon: {
              color: "#5f5f5f",
              fontSize: 16,
            },
            iconContainer: { paddingTop: 2 },
          }}
        />
      </div>

      <div className="agentic-report-list-scroll">
        {filteredItems.length === 0 ? (
          <div
            style={{
              padding: "12px",
              textAlign: "center",
              color: "#666",
              fontSize: "13px",
            }}
          >
            {searchQuery ? "No matches found" : "No templates"}
          </div>
        ) : (
          filteredItems.map((item, idx) => {
            const label = type === "agentic" ? item.label : item.title;
            return (
              <div
                key={idx}
                className="agentic-report-menu-item"
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(item);
                }}
              >
                <span className="temp-label">{label}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SubMenuWithSearch;
